<template>
  <form action="">
    <div class="form-group">
      <div>
        <label class="mr-4">
          <input
            type="radio"
            v-model="bookingType"
            value="GUEST"
            class="mr-2"
          />
          Guest Visitor
        </label>
        <label>
          <input
            type="radio"
            v-model="bookingType"
            value="DELIVERY"
            class="mr-2"
          />
          Delivery/Package
        </label>
      </div>
    </div>

    <div v-if="bookingType === 'GUEST'" style="display: flex; gap: 10px">
      <div class="form-group" style="width: 100%">
        <label class="required">First Name</label>
        <input
          type="text"
          class="form-control"
          v-model="visitor.firstName"
          placeholder="Enter first name"
          required
        />
      </div>
      <div class="form-group" style="width: 100%">
        <label class="required">Last Name</label>
        <input
          type="text"
          class="form-control"
          v-model="visitor.lastName"
          placeholder="Enter last name"
          required
        />
      </div>
    </div>

    <div v-if="bookingType === 'GUEST'" style="display: flex; gap: 10px">
      <div class="form-group" style="width: 100%">
        <label>Email</label>
        <input
          type="email"
          class="form-control"
          v-model="visitor.email"
          placeholder="example@email.com"
        />
      </div>
      <div class="form-group" style="width: 100%">
        <label>Phone Number</label>
        <input
          type="text"
          class="form-control"
          v-model="visitor.phone"
          placeholder="Enter phone number"
        />
      </div>
    </div>

    <div v-if="bookingType === 'DELIVERY'">
      <div class="form-group">
        <label class="required">Company Name</label>
        <input
          type="text"
          class="form-control"
          v-model="visitor.name"
          placeholder="Enter company name"
          required
        />
      </div>
    </div>

    <div class="form-group">
      <label>Number of People</label>
      <input
        type="number"
        class="form-control"
        v-model="numberOfPeople"
        min="1"
        placeholder="Enter number of people"
      />
    </div>

    <div class="form-group">
      <label>Number of Entries</label>
      <select class="form-control" v-model="numberOfEntries">
        <option :value="null">Unlimited (during date range)</option>
        <option :value="1">Single Entry</option>
        <option :value="2">2 Entries</option>
        <option :value="3">3 Entries</option>
        <option :value="5">5 Entries</option>
        <option :value="10">10 Entries</option>
      </select>
    </div>

    <div class="form-group">
      <label>Vehicle Registration</label>
      <input
        type="text"
        class="form-control"
        v-model="vehicleRegistration"
        placeholder="Enter vehicle registration"
      />
    </div>
    <div style="display: flex; gap: 10px">
      <div class="form-group">
        <label>Start Date</label>
        <date-picker
          style="width: 100%"
          v-model="startDate"
          valueType="format"
          type="date"
          input-class="form-control"
        ></date-picker>
      </div>
      <div class="form-group">
        <label>Start Time</label>
        <date-picker
          style="width: 100%"
          v-model="startTime"
          valueType="format"
          type="time"
          format="HH:mm"
          input-class="form-control"
        ></date-picker>
      </div>
    </div>
    <div style="display: flex; gap: 10px">
      <div class="form-group">
        <label>End date</label>
        <date-picker
          style="width: 100%"
          v-model="endDate"
          valueType="format"
          type="date"
          input-class="form-control"
        ></date-picker>
      </div>
      <div class="form-group">
        <label>End Time</label>
        <date-picker
          style="width: 100%"
          v-model="endTime"
          valueType="format"
          type="time"
          format="HH:mm"
          input-class="form-control"
        ></date-picker>
      </div>
    </div>

    <div class="form-group">
      <label class="toggle-switch-label">
        <input type="checkbox" v-model="isFrequentVisitor" />
        <span class="ml-2"
          >This person visits me often (save as frequent visitor)</span
        >
      </label>
    </div>

    <div class="mt-4">
      <button
        class="btn btn-primary btn-block"
        @click="saveVisit($event)"
        :disabled="saving"
      >
        <span v-if="saving">
          <i class="fas fa-spinner fa-spin"></i> Saving...
        </span>
        <span v-else>Submit</span>
      </button>
    </div>
  </form>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import Autocomplete from "vuejs-auto-complete";
import visitService from "../../service/appointment.service";

export default {
  name: "create-visit-form",
  components: {
    DatePicker,
    Autocomplete
  },
  data() {
    return {
      bookingType: "GUEST",
      visitor: {
        firstName: undefined,
        lastName: undefined,
        email: undefined,
        phone: undefined,
        name: undefined
      },
      numberOfPeople: 1,
      numberOfEntries: null,
      vehicleRegistration: undefined,
      isFrequentVisitor: false,
      startDate: undefined,
      endDate: undefined,
      startTime: undefined,
      endTime: undefined,
      success: false,
      saving: false
    };
  },
  methods: {
    getCurrentDate() {
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = (currentDate.getMonth() + 1).toString().padStart(2, "0");
      const day = currentDate
        .getDate()
        .toString()
        .padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    getDefaultTime() {
      const date = new Date();
      const hours = date
        .getHours()
        .toString()
        .padStart(2, "0");
      const minutes = date
        .getMinutes()
        .toString()
        .padStart(2, "0");
      return `${hours}:${minutes}`;
    },

    saveVisit(e) {
      e.preventDefault();

      // Validation
      if (this.bookingType === "GUEST") {
        if (!this.visitor.firstName || !this.visitor.lastName) {
          this.fireNotification(
            "warning",
            "",
            "First name and last name are required"
          );
          return;
        }
      } else if (this.bookingType === "DELIVERY") {
        if (!this.visitor.name) {
          this.fireNotification("warning", "", "Company name is required");
          return;
        }
      }

      // Get context ID (customer ID for URL path) and logged-in user ID (person being visited)
      const contextId =
        localStorage.getItem("contextId") ||
        localStorage.getItem("selectedContextId");
      const personBeingVisitedId = localStorage.getItem("actorId");

      if (!contextId) {
        this.fireNotification(
          "error",
          "Error",
          "Customer context not found. Please log in again."
        );
        return;
      }

      this.saving = true;

      let appointment = {
        bookingType: this.bookingType,
        firstName:
          this.bookingType === "GUEST" ? this.visitor.firstName : undefined,
        lastName:
          this.bookingType === "GUEST" ? this.visitor.lastName : undefined,
        email: this.bookingType === "GUEST" ? this.visitor.email : undefined,
        phone: this.bookingType === "GUEST" ? this.visitor.phone : undefined,
        name:
          this.bookingType === "GUEST"
            ? `${this.visitor.firstName} ${this.visitor.lastName}`
            : this.visitor.name,
        destinationId: contextId,
        personBeingVisitedId: personBeingVisitedId,
        numberOfPeople: this.numberOfPeople,
        numberOfEntries: this.numberOfEntries,
        vehicleRegistration: this.vehicleRegistration,
        isFrequentVisitor: this.isFrequentVisitor,
        startDate: this.startDate,
        endDate: this.endDate,
        startTime: this.startTime + ":00+00:00",
        endTime: this.endTime + ":00+00:00"
      };

      visitService
        .create(contextId, appointment)
        .then(response => {
          let code = response.data.code;
          if (code === "SUCCESS") {
            this.visit = response.data.data;
            this.success = true;
            document.getElementById("create_visit_modal").click();
            this.$parent.retrieveVisits();
            this.$router.push("/visits");
            Swal.fire({
              icon: "success",
              title: "Done",
              text: "Successfully created visit",
              footer: '<a href="">Why do I have this issue?</a>'
            });
          } else {
            this.fireNotification("warning", "", response.data.narrative);
          }
        })
        .catch(e => {
          console.log(e);
          if (
            e.response &&
            (e.response.status === 401 ||
              e.response.status === 403 ||
              e.response.status === 409)
          ) {
            return;
          }
          this.fireNotification("error", "Oops", "Error occurred");
        })
        .finally(() => {
          this.saving = false;
        });
    },
    newVisit() {
      this.visit = {};
    },
    fireNotification(icon, title, message) {
      Swal.fire({
        icon: icon,
        title: title,
        text: message,
        footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    }
  },
  mounted() {
    if (!this.currentUser) {
      this.$router.push("/login");
      return;
    }
    this.startDate = this.getCurrentDate();
    this.endDate = this.getCurrentDate();
    this.startTime = this.getDefaultTime();
    this.endTime = this.getDefaultTime();
  }
};
</script>

<style scoped>
.toggle-switch-label {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.toggle-switch-label input[type="checkbox"] {
  margin-right: 8px;
  width: 18px;
  height: 18px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/appointments/CreateVisitFormV2.vue